import React from "react";

interface SidebarDetailItemProps {
  icon: React.ComponentType<React.SVGProps<SVGSVGElement>>;
  label: string;
  value?: React.ReactNode;
  children?: React.ReactNode;
}

export const SidebarDetailItem: React.FC<SidebarDetailItemProps> = ({
  icon: Icon,
  label,
  value,
  children,
}) => {
  return (
    <div className="mb-4 flex flex-wrap gap-5">
      <label className="flex gap-2 items-center text-sm font-medium text-gray-900 leading-5 min-w-[140px] max-w-[200px] break-words">
        <Icon className="w-4 h-4 shrink-0" />
        <span>{label}</span>
      </label>
      <div className="flex-1 min-w-0 text-sm text-gray-900">
        {children ?? <span>{value}</span>}
      </div>
    </div>
  );
};

export default SidebarDetailItem;

